// Imports
	//Icons
	import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
	import { faBoxOpen } from "@fortawesome/free-solid-svg-icons"
	
	
	
	
// rafce
	const BannerCombos = () => {

		const scrollToBottom = () => {
			window.scrollTo({top:(0, document.body.scrollHeight), left:0, behavior: 'smooth'});
		}

		return (
			<div className="banner-combos">
				<p onClick={scrollToBottom}> 
					Los combos pueden modificarse a su necesidad.
				</p>
				<FontAwesomeIcon icon={ faBoxOpen } onClick={scrollToBottom} />
				<p onClick={scrollToBottom}>
					Consulte para más información
				</p>
			</div>
		)
	}

export default BannerCombos
